/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPEMPLOYMENTSTATUS } from './IAPEMPLOYMENTSTATUS';
import {
    IAPEMPLOYMENTSTATUSFromJSON,
    IAPEMPLOYMENTSTATUSFromJSONTyped,
    IAPEMPLOYMENTSTATUSToJSON,
} from './IAPEMPLOYMENTSTATUS';
import type { IAPINDUSTRY } from './IAPINDUSTRY';
import {
    IAPINDUSTRYFromJSON,
    IAPINDUSTRYFromJSONTyped,
    IAPINDUSTRYToJSON,
} from './IAPINDUSTRY';
import type { IAPINDUSTRYSECTOR } from './IAPINDUSTRYSECTOR';
import {
    IAPINDUSTRYSECTORFromJSON,
    IAPINDUSTRYSECTORFromJSONTyped,
    IAPINDUSTRYSECTORToJSON,
} from './IAPINDUSTRYSECTOR';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface ThirdPartyIndividualEmploymentAndTax
 */
export interface ThirdPartyIndividualEmploymentAndTax {
    /**
     * 
     * @type {IAPEMPLOYMENTSTATUS}
     * @memberof ThirdPartyIndividualEmploymentAndTax
     */
    employmentStatusId?: IAPEMPLOYMENTSTATUS;
    /**
     * 
     * @type {IAPINDUSTRYSECTOR}
     * @memberof ThirdPartyIndividualEmploymentAndTax
     */
    industrySectorId?: IAPINDUSTRYSECTOR;
    /**
     * 
     * @type {IAPINDUSTRY}
     * @memberof ThirdPartyIndividualEmploymentAndTax
     */
    industryId?: IAPINDUSTRY;
    /**
     * 
     * @type {string}
     * @memberof ThirdPartyIndividualEmploymentAndTax
     */
    otherIndustrySectorName?: string;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof ThirdPartyIndividualEmploymentAndTax
     */
    isUSCitizen?: IAPYESORNO;
}

/**
 * Check if a given object implements the ThirdPartyIndividualEmploymentAndTax interface.
 */
export function instanceOfThirdPartyIndividualEmploymentAndTax(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ThirdPartyIndividualEmploymentAndTaxFromJSON(json: any): ThirdPartyIndividualEmploymentAndTax {
    return ThirdPartyIndividualEmploymentAndTaxFromJSONTyped(json, false);
}

export function ThirdPartyIndividualEmploymentAndTaxFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThirdPartyIndividualEmploymentAndTax {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'employmentStatusId': !exists(json, 'EmploymentStatusId') ? undefined : IAPEMPLOYMENTSTATUSFromJSON(json['EmploymentStatusId']),
        'industrySectorId': !exists(json, 'IndustrySectorId') ? undefined : IAPINDUSTRYSECTORFromJSON(json['IndustrySectorId']),
        'industryId': !exists(json, 'IndustryId') ? undefined : IAPINDUSTRYFromJSON(json['IndustryId']),
        'otherIndustrySectorName': !exists(json, 'OtherIndustrySectorName') ? undefined : json['OtherIndustrySectorName'],
        'isUSCitizen': !exists(json, 'IsUSCitizen') ? undefined : IAPYESORNOFromJSON(json['IsUSCitizen']),
    };
}

export function ThirdPartyIndividualEmploymentAndTaxToJSON(value?: ThirdPartyIndividualEmploymentAndTax | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'EmploymentStatusId': IAPEMPLOYMENTSTATUSToJSON(value.employmentStatusId),
        'IndustrySectorId': IAPINDUSTRYSECTORToJSON(value.industrySectorId),
        'IndustryId': IAPINDUSTRYToJSON(value.industryId),
        'OtherIndustrySectorName': value.otherIndustrySectorName,
        'IsUSCitizen': IAPYESORNOToJSON(value.isUSCitizen),
    };
}

